import { Component, OnInit, inject } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DialogTrackingService } from "../../../services/dialog/dialog-tracking.service";
import { RnErrorHandlerService } from "../../../services/rn-error-handler/rn-error-handler.service";
import { OrganizationService } from "../../../services/rnapi2-service/apis/api";
import { RnObjectRNResponseRelay, RnOrganizationContainerDelete } from '../../../services/rnapi2-service/models/models';
import { DeleteFldrConfig } from "./delete-fldr-config";
import { ToasterService, ToastType } from "@rn-platform/frontend-shared-data-access-toaster";
@Component({
    selector: "app-delete-fldr-confirm",
    templateUrl: "./delete-fldr-confirm.component.html",
    styleUrls: ["./delete-fldr-confirm.component.scss"],
    standalone: false
})
export class DeleteFldrConfirmComponent implements OnInit {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  private orgService = inject(OrganizationService);
  private rnErrorHandlerService = inject(RnErrorHandlerService);
  private toasterService = inject(ToasterService);
  private dialogTrackService = inject(DialogTrackingService);

  public folderConfig: DeleteFldrConfig;
  working = false;

  ngOnInit(): void {
    this.folderConfig = this.config.data as DeleteFldrConfig;
  }

  close() {
    if (!this.working) {
      this.dialogTrackService.closeDialog(this.ref, false);
    }
  }

  public actualDeleteFolder() {
    this.working = true;
    const payload = new RnOrganizationContainerDelete();
    payload.OrgFolderID = this.folderConfig.OrgFolderID;
    payload.AffectedOrganizationId = this.folderConfig.OrganizationID;

    this.orgService
      .apiV2OrganizationsDeleteorgcontainerPost(payload, "response")
      .subscribe({
        next: (r) => {
          if (r.body.Success) {
            setTimeout(() => {
              this.dialogTrackService.closeDialog(this.ref, true);
            }, 5000);
          }
        },
        error: (error) => {
          const rnErr = error as RnObjectRNResponseRelay;
          if (rnErr) {
            this.rnErrorHandlerService.handleError(
              "An error occurred attempting to delete a folder.",
              rnErr.Messages,
            );
          }
          const message = 'There was an error deleting the folder.';
          const id = 'apphub-delete-folder-error-toat';
          this.toasterService.addToast(ToastType.Error_, message, message, id, id);
          this.working = false;
        },
      });
  }
}
